<app-detail-list-template
    *ngIf="Data$ | async as data"
    style="padding: 0"
    [Inline]="Inline"
    [ngStyle]="{'margin-top': Inline ? '0' : '-1.5rem'}"
    [Data]="data"
    [Editing]="Editing$ | async"
    [DisableAutofocus]="true"
>
</app-detail-list-template>
